import ModuleRoute from "components/ModuleRoute/ModuleRoute";
import PageRoute from "components/PageRoute/PageRoute";
import React from "react";
import { RouteObject } from "react-router-dom";

const GroupsModule = React.lazy(() => import("./GroupsModule"));
const GroupsSegmentsPage = React.lazy(() => import("./page/GroupsSegmentsPage/GroupsSegmentsPage"));
const GroupsOccasionsPage = React.lazy(() => import("./page/GroupsOccasionsPage/GroupsOccasionsPage"));
const GroupsQualQuestionPage = React.lazy(
  () => import("./page/GroupsQualQuestionPage/GroupsQualQuestionPage"),
);
const GroupsTextQuestionPage = React.lazy(
  () => import("./page/GroupsTextQuestionPage/GroupsTextQuestionPage"),
);
const GroupsTestOptionPage = React.lazy(() => import("./page/GroupsTestOptionPage/GroupsTestOptionPage"));
const UandAPage = React.lazy(() => import("./page/UandAPage/UandAPage"));
const GroupsSingleSegmentPage = React.lazy(
  () => import("./page/GroupsSingleSegmentPage/GroupsSingleSegmentPage"),
);
const GroupsCrosstabPage = React.lazy(() => import("./page/GroupsCrosstabPage/GroupsCrosstabPage"));
const GroupsSingleOccasionPage = React.lazy(
  () => import("./page/GroupsSingleOccasionPage/GroupsSingleOccasionPage"),
);

export const GroupsModuleRoutes: RouteObject = {
  path: ":clientId/groups/:projectGroupId/*",
  element: <ModuleRoute El={GroupsModule} moduleName="groups" />,
  children: [
    {
      path: "segments",
      element: <PageRoute El={GroupsSegmentsPage} />,
    },
    {
      path: "segments/:segmentId",
      element: <PageRoute El={GroupsSingleSegmentPage} />,
    },
    {
      path: "occasions",
      element: <PageRoute El={GroupsOccasionsPage} />,
    },
    {
      path: "occasions/:occasionId",
      element: <PageRoute El={GroupsSingleOccasionPage} />,
    },
    {
      path: ":tab?",
      element: <PageRoute El={UandAPage} />,
    },
    {
      path: "qual/:pageType/:questionId",
      element: <PageRoute El={GroupsQualQuestionPage} />,
    },
    {
      path: "text/:questionId",
      element: <PageRoute El={GroupsTextQuestionPage} />,
    },
    {
      path: "test-options/:tab",
      element: <PageRoute El={GroupsTestOptionPage} />,
    },
    {
      path: "crosstab/:questionId?",
      element: <PageRoute El={GroupsCrosstabPage} />,
    },
  ],
};
